import React from 'react';
import PropTypes from 'prop-types';

import { FooterLinks, ItemLink, Item, FooterLinksHeader } from './styles';

const LinkList = ({ pageData }) => {
  const { navigationLink, childNavigationItems, menuLabel } = pageData;
  const navLink = navigationLink ? navigationLink[0] : null;

  if (!navLink) return null;

  return (
    <>
      <FooterLinksHeader>{menuLabel}</FooterLinksHeader>
      <FooterLinks>
        <Item>
          <ItemLink link={navLink}>{navLink.title}</ItemLink>
        </Item>
        {childNavigationItems &&
          childNavigationItems.map(
            (item, i) =>
              item.navigationLink && (
                <Item key={i}>
                  <ItemLink link={item.navigationLink[0]}>
                    {item.menuLabel || item.title}
                  </ItemLink>
                </Item>
              )
          )}
      </FooterLinks>
    </>
  );
};

LinkList.propTypes = {
  pageData: PropTypes.shape({
    menuLabel: PropTypes.string.isRequired,
    navigationLink: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
      })
    ),
    childNavigationItems: PropTypes.arrayOf(
      PropTypes.shape({
        navigationLink: PropTypes.array,
        menuLabel: PropTypes.string,
        title: PropTypes.string,
      })
    ),
  }),
};

export default React.memo(LinkList);
